// extracted by mini-css-extract-plugin
module.exports = {"pointerEventsButton":"Network_pointerEventsButton__3jUQ0","pointerEventsButtonActive":"Network_pointerEventsButtonActive__3VRgy"};